import { createAsyncAction } from 'redux-promise-middleware-actions';
import api from '../Api/apiIS';
import { getActionTypesResult } from '../utils';

export const licensesPaymentConstants = {
    LICENSE_PLANNED_INCONSISTENT_LOADED: 'LICENSE_PLANNED_INCONSISTENT_LOADED',
    LICENSE_PLANNED_PAYMENT_LOADED: 'LICENSE_PLANNED_PAYMENT_LOADED',
    LICENSE_PLANNED_PAYMENT_CREATED: 'LICENSE_PLANNED_PAYMENT_CREATED',
    LICENSE_PLANNED_PAYMENTS_CREATED: 'LICENSE_PLANNED_PAYMENTS_CREATED',
    LICENSE_PLANNED_PAYMENT_UPDATED: 'LICENSE_PLANNED_PAYMENT_UPDATED',
    LICENSE_PLANNED_PAYMENT_DELETED: 'LICENSE_PLANNED_PAYMENT_DELETED',
    LICENSE_ACTUAL_INCONSISTENT_LOADED: 'LICENSE_ACTUAL_INCONSISTENT_LOADED',
    LICENSE_ACTUAL_PAYMENT_LOADED: 'LICENSE_ACTUAL_PAYMENT_LOADED',
    LICENSE_ACTUAL_PAYMENT_CREATED: 'LICENSE_ACTUAL_PAYMENT_CREATED',
    LICENSE_ACTUAL_PAYMENT_UPDATED: 'LICENSE_ACTUAL_PAYMENT_UPDATED',
    LICENSE_ACTUAL_PAYMENT_DELETED: 'LICENSE_ACTUAL_PAYMENT_DELETED',
    LICENSE_CLEAR_PAYMENT: 'LICENSE_CLEAR_PAYMENT',
    LICENSE_GET_END_DATE_PLANNED_LOADED: 'LICENSE_GET_END_DATE_PLANNED_LOADED',
    LICENSE_GET_LAST_DATE_PLANNED_LOADED: 'LICENSE_GET_EXIST_DATE_PLANNED_LOADED',
    LICENSE_GET_EXIST_DATE_PLANNED_LOADED: 'LICENSE_GET_EXIST_DATE_PLANNED_LOADED',
    LICENSE_GET_EXIST_DATE_ACTUAL_LOADED: 'LICENSE_GET_EXIST_DATE_ACTUAL_LOADED',
};

export const licensesPaymentFulfilledConstants = getActionTypesResult(licensesPaymentConstants, '_FULFILLED');
export const licensesPaymentPendingConstants = getActionTypesResult(licensesPaymentConstants, '_PENDING');
export const licensesPaymentRejectedConstants = getActionTypesResult(licensesPaymentConstants, '_REJECTED');

export const clearPayments = () => ({
    type: licensesPaymentConstants.LICENSE_CLEAR_PAYMENT
});

export const fetchLicenseSchedulePlanned =
    createAsyncAction(licensesPaymentConstants.LICENSE_PLANNED_PAYMENT_LOADED, query =>
        api.get('license/schedule/planned', { params: query, paramsSerializer: { indexes: null } }).then(res => res.data)
    );

export const fetchInconsistentLicenseSchedulePlanned =
    createAsyncAction(licensesPaymentConstants.LICENSE_PLANNED_INCONSISTENT_LOADED, id =>
        api.get(`license/schedule/planned/payments/inconsistent/dates/${id}`).then(res => res.data)
    );

export const fetchInconsistentLicenseScheduleActual =
    createAsyncAction(licensesPaymentConstants.LICENSE_ACTUAL_INCONSISTENT_LOADED, id =>
        api.get(`license/schedule/actual/payments/inconsistent/dates/${id}`).then(res => res.data)
    );

export const fetchEndDateSchedulePlanned =
    createAsyncAction(licensesPaymentConstants.LICENSE_GET_END_DATE_PLANNED_LOADED, query =>
        api.get('license/schedule/planned/payments/dates', { params: query, paramsSerializer: { indexes: null } }).then(res => res.data));

export const fetchExistPlannedData =
    createAsyncAction(licensesPaymentConstants.LICENSE_GET_EXIST_DATE_PLANNED_LOADED, data =>
        api.get(`license/schedule/planned/payment/date/${data.plannedPaymentStartDate}/${data.licenseId}`).then(res => res.data));

export const fetchExistActualData =
    createAsyncAction(licensesPaymentConstants.LICENSE_GET_EXIST_DATE_ACTUAL_LOADED, data =>
        api.get(`license/schedule/actual/payment/date/${data.actualPaymentDate}/${data.licenseId}`).then(res => res.data));

export const fetchLastPayment =
    createAsyncAction(licensesPaymentConstants.LICENSE_GET_LAST_DATE_PLANNED_LOADED, id =>
        api.get(`license/schedule/planned/payment/last/${id}`).then(res => res.data));

export const fetchLicenseScheduleActual =
    createAsyncAction(licensesPaymentConstants.LICENSE_ACTUAL_PAYMENT_LOADED, query =>
        api.get('license/schedule/actual', { params: query, paramsSerializer: { indexes: null } }).then(res => res.data)
    );

export const saveLicensePlannedPayments =
    createAsyncAction(licensesPaymentConstants.LICENSE_PLANNED_PAYMENTS_CREATED, plannedPayment =>
        api.post('license/schedule/planned/payments', plannedPayment).then(res => res.data)
    );

export const saveLicensePlannedPayment =
    createAsyncAction(licensesPaymentConstants.LICENSE_PLANNED_PAYMENT_CREATED, plannedPayment =>
        api.post('license/schedule/planned/payment', plannedPayment).then(res => res.data)
    );

export const saveLicenseActualPayment =
    createAsyncAction(licensesPaymentConstants.LICENSE_ACTUAL_PAYMENT_CREATED, actualPayment =>
        api.post('license/schedule/actual/payment', actualPayment).then(res => res.data)
    );

export const updateLicensePlannedPayment =
    createAsyncAction(licensesPaymentConstants.LICENSE_PLANNED_PAYMENT_UPDATED, payments =>
        api.put('license/schedule/planned/payments', payments)
            .then(res => res.data));

export const updateLicenseActualPayment =
    createAsyncAction(licensesPaymentConstants.LICENSE_ACTUAL_PAYMENT_UPDATED, payments =>
        api.put('license/schedule/actual/payments', payments)
            .then(res => res.data));

export const deleteLicensePlannedPayment =
    createAsyncAction(licensesPaymentConstants.LICENSE_PLANNED_PAYMENT_DELETED, data =>
        api.delete('license/schedule/planned/payments', { data }).then(res => res.data));

export const deleteLicenseActualPayment =
    createAsyncAction(licensesPaymentConstants.LICENSE_ACTUAL_PAYMENT_DELETED, data =>
        api.delete('license/schedule/actual/payments', { data }).then(res => res.data));
